import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { services } from '@/mocks/services';

const [featuredOne, featuredTwo, ...rest] = services;

export default function Services() {
  return (
    <section id="expertises" className="relative bg-background-50 py-20 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-foreground-950/10" />
      <div className="container-wide">
        <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <Reveal>
            <SectionHeading
              label="Nos expertises"
              title={
                <>
                  Dix métiers,
                  <br />
                  une seule exigence
                </>
              }
              description="SGSCTIC réunit sous un même toit les compétences nécessaires à vos projets industriels : de la conception métallique à la formation de vos équipes."
            />
          </Reveal>
          <Reveal delay={140}>
            <Link
              to="/offres"
              className="group inline-flex items-center gap-3 whitespace-nowrap rounded-md border border-foreground-950/20 px-6 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-foreground-950 transition-colors duration-300 hover:border-foreground-950 hover:bg-foreground-950 hover:text-background-50"
            >
              Toutes nos offres
              <i className="ri-arrow-right-line text-base transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>

        {/* Featured duo */}
        <div className="mt-14 grid gap-5 md:grid-cols-2">
          {[featuredOne, featuredTwo].map((service, index) => (
            <Reveal key={service.slug} delay={index * 120}>
              <Link
                to="/offres"
                className="group relative block h-full overflow-hidden rounded-lg bg-foreground-950"
              >
                <div className="card-img-zoom relative aspect-[16/12] w-full overflow-hidden md:aspect-[16/11]">
                  <img
                    src={service.image}
                    alt={service.title}
                    title={`${service.title} — SGSCTIC Douala`}
                    className="h-full w-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/45 to-foreground-950/5" />
                </div>
                <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
                  <div className="flex items-center gap-3">
                    <span className="label-mono text-primary-300">{service.index}</span>
                    <span className="h-px w-6 bg-primary-400/70" />
                    <span className="label-mono text-background-300">Expertise phare</span>
                  </div>
                  <h3 className="mt-3 font-heading text-3xl font-semibold uppercase leading-none text-background-50 md:text-4xl">
                    {service.title}
                  </h3>
                  <p className="mt-3 max-w-md text-sm leading-relaxed text-background-200">
                    {service.short}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-primary-300">
                    Voir le détail
                    <i className="ri-arrow-right-up-line transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        {/* Remaining grid */}
        <div className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {rest.map((service, index) => (
            <Reveal key={service.slug} delay={(index % 4) * 90}>
              <Link
                to="/offres"
                className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-foreground-950/10 bg-background-100 transition-all duration-300 hover:border-primary-400"
              >
                <div className="card-img-zoom relative aspect-[16/11] w-full overflow-hidden bg-background-200">
                  <img
                    src={service.image}
                    alt={service.title}
                    title={`${service.title} — SGSCTIC`}
                    className="h-full w-full object-cover object-top"
                  />
                  <span className="absolute left-3 top-3 bg-background-50/95 px-2 py-1 font-label text-[10px] tracking-[0.2em] text-primary-700">
                    {service.index}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-xl font-semibold uppercase leading-tight text-foreground-950">
                    {service.title}
                  </h3>
                  <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">
                    {service.short}
                  </p>
                  <span className="mt-4 flex items-center justify-between border-t border-foreground-950/10 pt-3 text-[10px] uppercase tracking-[0.18em] text-foreground-500">
                    En savoir plus
                    <i className="ri-arrow-right-line text-base text-primary-500 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}